import React from "react";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";

/**
 * Avatar que aplica crop metadata (x, y, scale) sobre a thumbnail.
 *
 * Props:
 *   fotoPerfil  - JSONB: { original, thumbnail, crop: { x, y, scale } }
 *   size        - tamanho em px (default 40)
 *   nome        - nome para fallback com iniciais
 *   style       - style extra no container
 */
const CroppedAvatar = ({ fotoPerfil, size = 40, nome, style }) => {
	if (!fotoPerfil?.thumbnail) {
		return (
			<Avatar
				size={size}
				icon={!nome && <UserOutlined />}
				style={{
					backgroundColor: "#7265e6",
					fontSize: size * 0.4,
					flexShrink: 0,
					...style,
				}}
			>
				{nome ? nome.charAt(0).toUpperCase() : null}
			</Avatar>
		);
	}

	const crop = fotoPerfil.crop;
	const imgSrc = fotoPerfil.original || fotoPerfil.thumbnail;

	// Sem crop metadata: center crop padrão
	if (!crop) {
		return (
			<div
				style={{
					width: size,
					height: size,
					borderRadius: "50%",
					overflow: "hidden",
					flexShrink: 0,
					...style,
				}}
			>
				<img
					src={imgSrc}
					alt={nome || "avatar"}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
					}}
				/>
			</div>
		);
	}

	// Com crop metadata: usar background-image para aplicar crop
	const scaleX = crop.scale || 1;
	const scaleY = crop.scaleY || scaleX;
	const bgPosX = (crop.x * 100).toFixed(2);
	const bgPosY = (crop.y * 100).toFixed(2);
	const bgSizeX = (scaleX * 100).toFixed(2);
	const bgSizeY = (scaleY * 100).toFixed(2);

	return (
		<div
			style={{
				width: size,
				height: size,
				borderRadius: "50%",
				overflow: "hidden",
				flexShrink: 0,
				backgroundImage: `url(${imgSrc})`,
				backgroundPosition: `${bgPosX}% ${bgPosY}%`,
				backgroundSize: `${bgSizeX}% ${bgSizeY}%`,
				backgroundRepeat: "no-repeat",
				...style,
			}}
		/>
	);
};

export default React.memo(CroppedAvatar);
